import { useSelector } from "react-redux";
import HorizantalBar from "../../../components/horizantalBar/HorizantalBar";
import PageLink from "../../../components/pageLink/PageLink";
import { allowedTabs } from "../../../constants/permissionCatalog";
import AppVersionNavigator from "../../../navigation/AppVersionNavigator";
import styles from "./appVersionSettings.module.css";

const AppVersionSettings = () => {
  const { rolePermissions } = useSelector((state) => state.user);
  const tabs = allowedTabs("app-settings", rolePermissions);

  return (
    <div className={styles.container}>
      <HorizantalBar>
        <div className={styles.linksWrapper}>
          {tabs.map((tab) => (
            <div key={tab.id} className={styles.linkWrapper}>
              <PageLink destination={`/dashboard/app-settings/${tab.path}`}>{tab.label}</PageLink>
            </div>
          ))}
        </div>
      </HorizantalBar>
      <AppVersionNavigator />
    </div>
  );
};

export default AppVersionSettings;
